import { OverlayBadgeDesignTokens } from '@primeuix/themes/types/overlaybadge';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/overlaybadge/index.ts
const ob = componentCommon.overlaybadge;

export const OverlaybadgeTelekomDT: OverlayBadgeDesignTokens = {
  root: {
    outline: {
      width: tNum(ob.outline.width),
      color: t(ob.outline.color),
    },
  },
};
